import Title from "../Title";
import Typo from "../Typo";
import FilterItem from "../FilterItem";
import JobItem from "../JobItem";
import Container from "../Container";
import {useRouter} from "next/router";
import localized from "../../locale/locales";
import {getJobFilters} from "../../helpers/jobs";
import {useState} from "react";
import useScrollTo from 'react-spring-scroll-to-hook';
import {config} from '@react-spring/web';

export default function SectionJobs({jobs, className = ''}) {
    const {locale} = useRouter();
    const {jobs: lang} = localized[locale];
    const [activeJob, setActiveJob] = useState(null);
    const [activeFilters, setActiveFilters] = useState([]);
    const availableFilters = getJobFilters(jobs);
    const {scrollTo} = useScrollTo(config.default);

    const handleJobItemClick = (e, key) => {
        if (key === activeJob) {
            setActiveJob(null);
        } else {
            setActiveJob(key);

            setTimeout(() => {
                scrollTo(e.target, -150);
            }, 500);
        }
    }

    return (
        <Container className={className}>
            <header className="text-center flex flex-col items-center gap-4">
                <Title>{lang.body.title}</Title>
                <Typo className="max-w-[40ch]">
                    {lang.body.subtitle}
                </Typo>
            </header>
            <div className="max-w-[600px] my-10 mx-auto flex flex-col gap-3 items-center justify-center">
                <div className="flex flex-wrap gap-3 items-center justify-center w-full">
                    {availableFilters.departments.map((item, key) => {
                        const active = activeFilters.includes(item);
                        return (
                            <FilterItem key={`FilterItem: ${key}`}
                                        active={active}
                                        onClick={() => setActiveFilters(active ? activeFilters.filter(i => i !== item) : [...activeFilters, item])}
                            >
                                {item}
                            </FilterItem>
                        )
                    })}
                </div>
                <div className="flex flex-wrap gap-3 items-center justify-center w-full">
                    {availableFilters.locations.map((item, key) => {
                        const active = activeFilters.includes(item);
                        return (
                            <FilterItem key={`FilterItem: ${key}`}
                                        active={active}
                                        onClick={() => setActiveFilters(active ? activeFilters.filter(i => i !== item) : [...activeFilters, item])}
                            >
                                {item}
                            </FilterItem>
                        )
                    })}
                </div>
            </div>

            <div className="flex flex-col items-center gap-7">
                {jobs.map((item, key) => {
                    const visible = activeFilters.length > 0 ? (activeFilters.includes(item.department) || activeFilters.includes(item.location)) : true;
                    if (!visible) return null;

                    const active = key === activeJob;

                    return (
                        <JobItem
                            {...item}
                            active={active}
                            onClick={(e) => handleJobItemClick(e, key)}
                            key={`JobItem: ${key}`}
                        />
                    )
                })}
                {jobs.length === 0 && (
                    <Typo className="text-center md:text-xl font-semibold">
                        {lang.noJobs}
                    </Typo>
                )}
            </div>
        </Container>
    )
}
